export default {
  button: {
    margin: 0,
    padding: 8,
    textTransform: 'none'
  },
};